__turbopack_context__.v({
  "cta": "_5EfDWW_cta",
  "empty": "_5EfDWW_empty",
  "linkOnly": "_5EfDWW_linkOnly",
  "prompt": "_5EfDWW_prompt",
  "root": "_5EfDWW_root",
  "stars": "_5EfDWW_stars",
});
